import { CURRENT_ENV } from 'config'
import { EnvironmentName } from 'config/envs'

// Types
type DomainEnvironmentsType = Exclude<EnvironmentName, 'localCloudStack'>

// Proper domains for environments
const domain = {
  local: 'https://dev.',
  test: 'https://test.',
  dev: 'https://dev.',
  staging: 'https://staging.',
  production: 'https://www.',
}

/**
 * Will output the correct Sketch website depending
 * on the environment
 *
 * @example
 * <Link href={`${SKETCH_WEBSITE}/home`}
 */
export const SKETCH_WEBSITE = `${
  domain[CURRENT_ENV as DomainEnvironmentsType]
}sketch.com`
